//----------------------------------------
// チェックデジット検証（mod10
//----------------------------------------
// scandit はSDK側でチェックデジットを検証したうえで結果を返すが、
// barkoder / scanbot は誤読した値をそのまま返すことがあるため、
// 商品登録APIを呼ぶ前にアプリ側で検証する。
//
// 対象：EAN-13 / EAN-8 / UPC-A / UPC-E
// 対象外（Code128など）は null を返し、検証せずそのまま通す。

//----------------------------------------
//UPC-A（12桁
//----------------------------------------

function isValidUPCA(upca12) {
	if (!/^\d{12}$/.test(upca12)) return false;

	const d = upca12.split("").map(Number);
	let odd = 0;
	let even = 0;

	for (let i = 0; i < 11; i++) {
		if (i % 2 === 0) {
			odd += d[i];
		} else {
			even += d[i];
		}
	}

	const check = (10 - ((odd * 3 + even) % 10)) % 10;
	return check === d[11];
}

//----------------------------------------
//UPC-E → UPC-A のデータ部（11桁）へ展開
//----------------------------------------

function expandUPCEtoUPCAData(upce8) {
	const m = /^([01])(\d)(\d)(\d)(\d)(\d)(\d)\d$/.exec(upce8);
	if (!m) return null;

	const [, S, a, b, c, d, e, N] = m;

	if (N === "0" || N === "1" || N === "2") return `${S}${a}${b}${N}0000${c}${d}${e}`;
	if (N === "3") return `${S}${a}${b}${c}00000${d}${e}`;
	if (N === "4") return `${S}${a}${b}${c}${d}00000${e}`;

	//N=5..9
	return `${S}${a}${b}${c}${d}${e}0000${N}`;
}

//----------------------------------------
//UPC-E（8桁
//----------------------------------------

function isValidUPCE(upce8) {
	if (!/^\d{8}$/.test(upce8)) return false;

	const data11 = expandUPCEtoUPCAData(upce8);
	if (!data11) return false;

	const d = data11.split("").map(Number);
	let odd = 0;
	let even = 0;

	for (let i = 0; i < 11; i++) {
		if (i % 2 === 0) {
			odd += d[i];
		} else {
			even += d[i];
		}
	}

	const calcCheck = (10 - ((odd * 3 + even) % 10)) % 10;
	return calcCheck === Number(upce8[7]);
}

//----------------------------------------
//EAN-13 / EAN-8
//----------------------------------------

function isValidEAN(barcode) {
	const len = barcode.length;
	const d = barcode.split("").map(Number);

	if (len === 13) {
		let sum = 0;
		for (let i = 0; i < 12; i++) {
			const n = d[11 - i];
			sum += i % 2 === 0 ? n * 3 : n;
		}
		return ((10 - (sum % 10)) % 10) === d[12];
	}

	if (len === 8) {
		let sum = 0;
		for (let i = 0; i < 7; i++) {
			const n = d[6 - i];
			sum += i % 2 === 0 ? n * 3 : n;
		}
		return ((10 - (sum % 10)) % 10) === d[7];
	}

	return false;
}

//----------------------------------------
//総合チェック（フォーマット自動判定
//----------------------------------------
// true  : チェックデジットOK
// false : チェックデジットNG（誤読
// null  : 検証対象外（Code128など）→ そのまま通す

export function isValidMod10Barcode(barcode) {
	if (!barcode) return null;

	if (/^\d{13}$/.test(barcode)) return isValidEAN(barcode);      //EAN-13
	if (/^\d{12}$/.test(barcode)) return isValidUPCA(barcode);     //UPC-A
	if (/^[01]\d{7}$/.test(barcode)) return isValidUPCE(barcode);  //UPC-E
	if (/^\d{8}$/.test(barcode)) return isValidEAN(barcode);       //EAN-8

	return null;
}
